var _rect, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _path2, _path3, _g2, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path4, _path5, _path6, _g3, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 245,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 8,
    width: 218,
    height: 218,
    rx: 16,
    fill: "#C8EAE4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 19,
    width: 133,
    height: 59.27,
    rx: 4,
    fill: "#fff"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79.091,
    y: 24.909,
    width: 26.591,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 111.591,
    y: 24.909,
    width: 26.591,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 79.091,
    y: 51.5,
    width: 7.386,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 92.386,
    y: 51.5,
    width: 7.386,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 105.682,
    y: 51.5,
    width: 14.773,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 79.091,
    y: 64.796,
    width: 48.75,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 79.091,
    y: 38.205,
    width: 67.954,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 25.909,
    y: 25,
    width: 47.273,
    height: 47.273,
    rx: 4,
    fill: "#13C2C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.733 35.25c.612 0 1.108.496 1.108 1.108v22.159a3.324 3.324 0 0 1-3.324 3.324H37.358a1.108 1.108 0 1 1 0-2.216h22.159c.612 0 1.108-.496 1.108-1.108v-22.16c0-.611.496-1.107 1.108-1.107Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.165 39.682c.612 0 1.108.496 1.108 1.108v22.159a3.324 3.324 0 0 1-3.324 3.324H41.79a1.108 1.108 0 0 1 0-2.216h22.16c.611 0 1.107-.496 1.107-1.108v-22.16c0-.611.496-1.107 1.108-1.107Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.142 30.818a3.324 3.324 0 0 0-3.324 3.324v19.943a3.324 3.324 0 0 0 3.324 3.324h19.943a3.324 3.324 0 0 0 3.324-3.324V34.142a3.324 3.324 0 0 0-3.324-3.324H35.142Zm-1.108 3.324c0-.612.496-1.108 1.108-1.108h19.943c.612 0 1.108.496 1.108 1.108v9.972h-4.136c-.43 0-.822.249-1.004.639l-2.504 5.366-5.722-15.258a1.108 1.108 0 0 0-2.041-.08l-3.321 7.117h-3.43v-7.756Zm0 9.972h4.137c.43 0 .822-.25 1.004-.64l2.504-5.365L47.4 53.365a1.108 1.108 0 0 0 2.042.08l3.32-7.116h3.431v7.755c0 .612-.496 1.108-1.108 1.108H35.142a1.108 1.108 0 0 1-1.108-1.108v-9.971Z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 87,
    width: 133,
    height: 59.27,
    rx: 4,
    fill: "#fff"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 188.091,
    y: 92.909,
    width: 26.591,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 220.591,
    y: 92.909,
    width: 26.591,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 188.091,
    y: 119.5,
    width: 7.386,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 201.386,
    y: 119.5,
    width: 7.386,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 214.682,
    y: 119.5,
    width: 14.773,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 188.091,
    y: 132.795,
    width: 48.75,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 188.091,
    y: 106.205,
    width: 67.954,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 134.909,
    y: 93,
    width: 47.273,
    height: 47.273,
    rx: 4,
    fill: "#13C2C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.733 103.25c.612 0 1.108.496 1.108 1.108v22.159a3.324 3.324 0 0 1-3.324 3.324h-22.159a1.108 1.108 0 1 1 0-2.216h22.159c.612 0 1.108-.496 1.108-1.108v-22.159c0-.612.496-1.108 1.108-1.108Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.165 107.682c.612 0 1.108.496 1.108 1.108v22.159a3.324 3.324 0 0 1-3.324 3.324H150.79a1.108 1.108 0 1 1 0-2.216h22.159c.612 0 1.108-.496 1.108-1.108V108.79c0-.612.496-1.108 1.108-1.108Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.142 98.818a3.324 3.324 0 0 0-3.324 3.324v19.943a3.324 3.324 0 0 0 3.324 3.324h19.943a3.324 3.324 0 0 0 3.324-3.324v-19.943a3.324 3.324 0 0 0-3.324-3.324h-19.943Zm-1.108 3.324c0-.612.496-1.108 1.108-1.108h19.943c.612 0 1.108.496 1.108 1.108v9.972h-4.136c-.43 0-.822.249-1.004.639l-2.504 5.366-5.722-15.258a1.107 1.107 0 0 0-2.041-.08l-3.321 7.117h-3.431v-7.756Zm0 9.972h4.137c.43 0 .822-.25 1.004-.64l2.504-5.365 5.721 15.257a1.108 1.108 0 0 0 2.042.08l3.321-7.116h3.43v7.755c0 .612-.496 1.108-1.108 1.108h-19.943a1.108 1.108 0 0 1-1.108-1.108v-9.971Z",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 155,
    width: 133,
    height: 59.27,
    rx: 4,
    fill: "#fff"
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 79.091,
    y: 160.909,
    width: 26.591,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 111.591,
    y: 160.909,
    width: 26.591,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 79.091,
    y: 187.5,
    width: 7.386,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 92.386,
    y: 187.5,
    width: 7.386,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 105.682,
    y: 187.5,
    width: 14.773,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 79.091,
    y: 200.795,
    width: 48.75,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 79.091,
    y: 174.205,
    width: 67.954,
    height: 7.386,
    rx: 3.693,
    fill: "#D7D8DA"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 25.909,
    y: 161,
    width: 47.273,
    height: 47.273,
    rx: 4,
    fill: "#13C2C2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.733 171.25c.612 0 1.108.496 1.108 1.108v22.159a3.324 3.324 0 0 1-3.324 3.324H37.358a1.108 1.108 0 1 1 0-2.216h22.159c.612 0 1.108-.496 1.108-1.108v-22.159c0-.612.496-1.108 1.108-1.108Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.165 175.682c.612 0 1.108.496 1.108 1.108v22.159a3.324 3.324 0 0 1-3.324 3.324H41.79a1.108 1.108 0 1 1 0-2.216h22.16c.611 0 1.107-.496 1.107-1.108V176.79c0-.612.496-1.108 1.108-1.108Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.142 166.818a3.324 3.324 0 0 0-3.324 3.324v19.943a3.324 3.324 0 0 0 3.324 3.324h19.943a3.324 3.324 0 0 0 3.324-3.324v-19.943a3.324 3.324 0 0 0-3.324-3.324H35.142Zm-1.108 3.324c0-.612.496-1.108 1.108-1.108h19.943c.612 0 1.108.496 1.108 1.108v9.972h-4.136c-.43 0-.822.249-1.004.639l-2.504 5.366-5.722-15.258a1.107 1.107 0 0 0-2.041-.08l-3.321 7.117h-3.43v-7.756Zm0 9.972h4.137c.43 0 .822-.25 1.004-.64l2.504-5.365 5.721 15.257a1.107 1.107 0 0 0 2.042.08l3.32-7.116h3.431v7.755c0 .612-.496 1.108-1.108 1.108H35.142a1.108 1.108 0 0 1-1.108-1.108v-9.971Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 9,
    width: 173,
    height: 99.27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 109,
    y: 77,
    width: 173,
    height: 99.27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 0,
    y: 145,
    width: 173,
    height: 99.27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.5f9d05cc67f2b8f9606a713b315bc683.svg";
export { ForwardRef as ReactComponent };